// extracted by mini-css-extract-plugin
export default {"styledTableHeader":"StyledTableHeader_styledTableHeader__f3QiQ"};